import { IntegrationRoutes } from '@/repository/tenant';
const { GetAllAvailable } = IntegrationRoutes;
import { _TENANT } from "@/state";

export default {
	namespaced: true,
	actions: {
		async index({ }) {
			if (_TENANT().blocked_apps.includes('integrations')) return;
			try {
				return await GetAllAvailable()
			}
			catch (error) {
				console.error('Could not get available integrations.', error);
				throw error;
			}
		}
	}
}